import { IPcr } from '../../../features/pcr/store/pcr.types'
import { IPatientVitals } from '../../../features/vitals/store/vitals.types'
import Logger from '../../../services/logger.service'
import { setValueForPathWithCreate } from '../../object.util'

export const addStrokeScaleScore = (pcr: any): IPcr => {
  try {
    if (
      pcr.patient &&
      pcr.patient.patientVitals?.length &&
      pcr.patient.patientVitals[0].vitalsStrokeScaleValues === undefined &&
      pcr.patient.patientVitals[0].strokeScaleScoreTotalPNNV === undefined &&
      pcr.patient.patientVitals[0].__isStrokeScaleScoreTotalPNNVEnabled === undefined
    ) {
      pcr.patient.patientVitals.forEach((vital: IPatientVitals) => {
        setValueForPathWithCreate(vital, 'vitalsStrokeScaleValues', [])
        setValueForPathWithCreate(vital, 'strokeScaleScoreTotalPNNV', null)
        setValueForPathWithCreate(vital, '__isStrokeScaleScoreTotalPNNVEnabled', false)
      })
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addStrokeScaleScore: ${error}`)
    throw error
  }
}
